
import { constant, isFunction, get } from 'lodash';
import { modules } from 'veritone-redux-common';
import veritoneApi from './veritoneApi';

const {
  config: { getConfig },
  auth: { selectOAuthToken }
} = modules;

function genGetUriFromTdoQuery(TDOId, assetTypeLog) {
  return `{
    temporalDataObject(id: ${TDOId}){
      assets(assetType: "${assetTypeLog}"){
        records {
          id
          signedUri
          uri
          assetType
        }
      }
    }
  }`;
}

export function getFileUriFromTdoApi(urlApi, TDOId, assetTypeLog) {
  return veritoneApi(urlApi.graphql)
  .post(
      '',
      { query: genGetUriFromTdoQuery(TDOId, assetTypeLog) }
  )
  .then(response => {
    const uri = get(
      response,
      'data.data.temporalDataObject.assets.records[0].signedUri',
      null
      );
    return ({ uri });
  }
  )
  .catch(error => ({
      error: true,
      ...error
  }))
}

export default async function callGraphQLApi({
  actionTypes: [requestType, successType, failureType],
  query,
  variables,
  operationName,
  bailout = constant(false),
  dispatch,
  getState
}) {
  if (!isFunction(dispatch) || !isFunction(getState)) {
    throw new Error('callGraphQLApi requires dispatch and getState functions')
  }

  const state = getState();
  const config = getConfig(state);
  const endpoint = `${config.apiRoot}/${config.graphQLEndpoint}`;
  const token = selectOAuthToken(state);

  const shouldBail = bailout(state);
  if (shouldBail) {
    return;
  }

  dispatch({ type: requestType, meta: { variables, operationName, query } });

  let response;
  try {
    response = await fetch(endpoint, {
      method: 'post',
      body: JSON.stringify({
        query,
        variables,
        operationName
      }),
      headers: {
        'x-veritone-application': '2d6e9991-e551-458c-9e9c-0c70aeaea456',
        Authorization: token ? `bearer ${token}` : null,
        'Content-Type': 'application/json'
      }
    }).then(r => r.json());
  } catch (e) {
    dispatch({
      type: failureType,
      error: true,
      payload: e,
      meta: { variables, operationName, query }
    });
    let error = new Error('API call failed');
    error.errors = [e];
    return error;
  }

  if (response.errors && response.errors.length) {
    dispatch({
      type: failureType,
      error: true,
      payload: response.errors,
      meta: { variables, operationName, query }
    });

    let error = new Error('API response included errors');
    error.errors = response.errors;
    return error;
  }

  dispatch({
    type: successType,
    payload: response.data,
    meta: { variables, operationName, query }
  });

  return response.data;
}
